import React from 'react'
import { Box, Typography, Tooltip } from '@mui/material'
import { OutlinedFlag } from '@mui/icons-material'
import theme from '../../theme'
import { ContentCategory } from '../../../types/campaign'
import { getParentCategoryId, getParentCategoryName } from '../../utils'

interface Props {
  creativeContentCategory: ContentCategory | null | undefined
  campaignContentCategory: ContentCategory | null | undefined
  allContentCategories?: ContentCategory[]
}

const ContentCategoryMismatchBadge = ({
  creativeContentCategory,
  campaignContentCategory,
  allContentCategories
}: Props) => {
  const hasContentCategoryMismatch = (() => {
    if (!creativeContentCategory || !campaignContentCategory) return false

    const campaignParentId = getParentCategoryId(campaignContentCategory)
    const creativeParentId = getParentCategoryId(creativeContentCategory)
    return creativeParentId !== campaignParentId
  })()

  if (!hasContentCategoryMismatch) {
    return null
  }

  const campaignParentName = getParentCategoryName(campaignContentCategory, allContentCategories)
  const creativeParentName = getParentCategoryName(creativeContentCategory, allContentCategories)

  const tooltipContent = (
    <Box>
      <Typography variant="body-5">
        Campaign Parent Category: {campaignParentName}
      </Typography>
      <br />
      <Typography variant="body-5">
        Creative Parent Category: {creativeParentName}
      </Typography>
    </Box>
  )

  return (
    <Tooltip title={tooltipContent} placement="top">
      <Box
        sx={{
          display: 'inline-flex',
          alignItems: 'center',
          padding: '2px 8px',
          borderRadius: '16px',
          border: `1px solid ${theme.palette['red-600']}`,
          gap: theme.space['8'],
          width: 'fit-content',
          cursor: 'default'
        }}
      >
        <OutlinedFlag sx={{ color: theme.palette['red-600'], fontSize: '16px' }} />
        <Typography variant="body-2" sx={{ color: theme.palette['red-600'], textTransform: 'uppercase', fontWeight: 600, lineHeight: '16px' }}>
          Category Mismatch
        </Typography>
      </Box>
    </Tooltip>
  )
}

export default ContentCategoryMismatchBadge
